// 1. Dependencies
import { nodeConfig } from '@/mixins';
import { modulesLoaded } from '@/helpers/modules-loader';

// 2. Configuration
const NAMESPACE = 'audience-paths';
const DEFAULT_SELECTOR = '[data-js-audience-paths]';
const DEFAULT_SETTINGS = {
	
};

// 3. Module
class AudiencePaths {
	/** @param {HTMLElement} node */
	constructor(node, config) {
		this.elNode = node;
		this.items = this.elNode.querySelectorAll('.audience-paths__item');

		this.config = config;
		this.exampleInstance;
	}

	hover(e) {
		const el = e.currentTarget;
		const siblings = Array.from(el.parentNode.children);
		const index = siblings.indexOf(el);

		this.elNode.dataset.hoverIndex = index + 2;
	}

	bindUI() {
		this.items.forEach((item) => {
			item.addEventListener('mouseenter', this.hover.bind(this));
		});
	}

	init() {
		this.bindUI();
	}
}

// 4. Factory Function
export default function factory(selector = DEFAULT_SELECTOR, settings = {}) {
	let listNode = document.querySelectorAll(selector);

	if (!listNode.length) return;

	return Array.from(listNode).map((node) => {
		let config = nodeConfig(node, NAMESPACE, settings, DEFAULT_SETTINGS);
		let module = new AudiencePaths(node, config);

		module.init();

		return module;
	});
}
